module.exports = __webpack_public_path__ + "static/media/Image-2_7.2c711975.jpg";